import { Theme } from '@mui/material'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import { palette } from 'c1ui'

export const useStyles = makeStyles((theme: Theme) => {
    return createStyles({
        checkbox: {
            '&:hover': {
                backgroundColor: 'transparent !important',
            },
            padding: 0,
        },
        button: {
            '&:hover': {
                backgroundColor: 'transparent !important',
            },
            padding: 0,
        },
        list: {
            marginTop: theme.spacing(3),
            paddingBottom: theme.spacing(2),
            backgroundColor: palette.grey[50],
        },
        nestedList: {},
        nestedListItem: {
            marginBottom: theme.spacing(1),
        },
        nestedListItemIcon: {
            fontSize: 12,
            margin: 0,
        },
        nestedListItemText: {
            marginLeft: theme.spacing(1),
            fontSize: 12,
        },
        countBox: {
            minWidth: 25,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        countBoxSelected: {
            backgroundColor: palette.primary.extraLight,
        },
        count: {},
    })
})
